$(document).ready(function(){

    $(document).on('click','.product-tab-wrap ul.tabs li',function(){
     console.log("hello");
      var tab_id = $(this).attr('data-tab');

      $('.product-tab-wrap ul.tabs li').removeClass('current');
      $('.tab-content').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
    });

  });




/* Vertical Slider Script Start */
setInterval(function () {
var cnflnt =  $(".fancybox-container").length;
if(cnflnt > 0 ){ 
  var bodyColor = $(".fancybox-container").css("opacity");
  if(bodyColor == '1'){
  if ($(".fancybox-container").hasClass("fancybox-can-swipe")) {
       $(".fancybox-button--close").trigger("click");
  }
  }
}
}, 800);


 $('.thumbVid video').attr('poster', 'https://cdn.shopify.com/s/files/1/0285/4436/8743/files/video-img.jpg?v=1735908157');
 $('.thumbVid img').attr('src', 'https://cdn.shopify.com/s/files/1/0285/4436/8743/files/video-img.jpg?v=1735908157');

$(document).on("click",".swatch-input__label",function(){
var color_nme = $(this).attr("title");
if($(".swicth_slider_nav[data-title='"+color_nme+"'] .thumbnail-image").length > 0){
$(".banner-slider").html('<div class="slider slider-nav thumb-image">'+$(".swicth_slider_nav[data-title='"+color_nme+"']").html()+'</div> <div class="slider slider-for">'+$(".swicth_slider_main[data-title='"+color_nme+"']").html()+'</div>');  
$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav',
  infinite:false
});
$('.slider-nav').slick({
    slidesToShow: 4,
  infinite:false,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping: true,
    responsive: [{
            breakpoint: 1024,
            settings: {
                vertical: true,
              infinite:false,
              slidesToShow: 4,
            }
        },{
            breakpoint: 992,
            settings: {
                vertical: false,
              infinite:false,
            }
        },
        {
            breakpoint: 768,
            settings: {
                vertical: false,
              infinite:false,
            }
        },
        {
            breakpoint: 580,
            settings: {
                vertical: false,
               // slidesToShow: 2,
              infinite:false,
            }
        },
        {
            breakpoint: 380,
            settings: {
                vertical: false,
                slidesToShow: 2,
                infinite:false,
            }
        }
    ]
});
}
});


var checked_value = $(".custom-Color .swtach-var-option input:checked").val();
$(".swatch-input__label[title='"+checked_value+"']").trigger("click");
$('body[template_name="product"]').css("opacity","1");

   $(document).on("click",".rt_side_content .main-slider-thumbs .inner_img",function(){
    var index = $(this).index();
    $(".lft_side_content .main-slider").slick('slickGoTo', index);
   });  

    $(document).on("click",".slider-for img",function(){

     var dataIndex = $('.thumbnail-image.slick-current.slick-active').data('slick-index');
    
      
     var i =0; 
    $(".lft_side_content .main-slider").html('')  
    $(".banner-slider .slider-nav .thumbnail-image").each(function(){
      var img_src= $(this).find("img").attr("src").replace("_1024x1024", "");
      //console.log(img_src);
      var get_src = img_src+'&width=470'; 
      $(".lft_side_content .main-slider").append('<div class="inner_img"><div style="display:none;" class="slides_main easyzoom easyzoom--overlay easyzoom--with-toggle"><a href="'+img_src+'" ><img src="'+get_src+'"></a></div> <div   class="nm_img" data-index="'+i+'"><img class="only_dk" src="'+get_src+'"> </div>');
       i++;
    });
    $(".rt_side_content .main-slider-thumbs").html('');
      $(".all-zoom-fun").html('');

     var i = 0; 
    $(".banner-slider .slider-nav .thumbnail-image").each(function(){
      var img_src= $(this).find("img").attr("src").replace("_1024x1024", "");
       $(".rt_side_content .main-slider-thumbs").append('<div class="inner_img" data-index="'+i+'"><img src="'+img_src+'"></div>');
       var dhtm= '<a href="'+img_src+'" class="fb"><img class="cusmzoom" src="'+img_src+'"></a>';
       $(".all-zoom-fun").append(dhtm);
       i++;
    });


    var dataIndexeArray = $('.main-slider-thumbs .inner_img').map(function() {
        return $(this).data('index');
    }).get();

    if (dataIndexeArray.includes(dataIndex)) {
         $('.main-slider-thumbs .inner_img').each(function() {
            if ($(this).data('index') === dataIndex) {
                $(this).addClass('active');
                  var self = $(this);
                setTimeout(function() {
                    self.trigger('click');
                }, 500);
            }
        });
    } else {
        console.log('No');
    }



      
    setTimeout(function() {
        if ($(window).width() >= 768 && $(window).width() <= 1279) {
          $('.main-slider .inner_img.slick-current.slick-active .nm_img').trigger('click');
        }
    },1000);

      
    $(".lft_side_content .main-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    infinite:true
    });

      
     $('.main-slider').on('afterChange', function(slick, slide,index){
          $('.main-slider-thumbs .inner_img').removeClass('active');
          $('.main-slider-thumbs .inner_img').eq(index).addClass('active');
    });



       

      
      
   $('.lft_side_content .easyzoom').easyZoom();   
    $(".sku_zoom").html($(".product__sku").html());
     $('#overlay-zoom').css('display','flex'); 
      $('body').addClass("product-popup-open");
      //$('.main-slider-thumbs .inner_img').first().addClass('active');

        $(".fb").fancybox({
        modal: false,
        overlayColor: '#000000',
        scrolling: 'yes',
        autoDimensions: true,
        onComplete: function () {
        // enable custom close button inside fancybox
        $(".fancybox-content").on("click", ".fancybox-content img", function (e) {
        e.preventDefault();
        }); // on
        },
        beforeShow: function() {
        $(".fancybox-container").addClass("og_opn"); 
        
        },
        afterShow : function() {
        $('.fancybox-button--zoom').click();
             $(".fancybox-container").removeClass("og_opn"); 
        
        }
        });  
    

    
  });


   $(document).on('click', '.main-slider .slick-prev, .main-slider .slick-next, .main-slider-thumbs .inner_img', function() {
      if ($(window).width() >= 768 && $(window).width() <= 1279) {
          $('.main-slider .inner_img.slick-current.slick-active .nm_img').trigger('click');
      }
  });




  $(document).on('click','.main-slider-thumbs .inner_img', function() {
    $('.inner_img').removeClass('active');
    $(this).addClass('active');
  });   



  $(document).on("click",".lft_side_content .main-slider .nm_img",function(){
    if($(window).width() > 767 ){
    $(this).hide();
    $(this).parent().find(".slides_main").show();
    }
    else{
      var current = parseInt($(this).attr("data-index"));
     $(".all-zoom-fun a").eq(current).trigger("click")
    }
    
  }); 

  $(document).on("click",".lft_side_content .main-slider .slides_main",function(){
      if($(window).width() > 767 ){
      $(this).hide();
      $(this).parent().find(".nm_img").show();
      }
      
    
  });



 
  $('#close-zoom').click(function() {
    $('#overlay-zoom').hide();
    //$('#overlay-zoom').fadeOut(300);
    $('body').removeClass("product-popup-open");
    $(".lft_side_content .main-slider").slick('unslick');
  });


$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav',
  infinite:false
});
$('.slider-nav').slick({
    slidesToShow: 4,
  infinite:false,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping: true,
    responsive: [{
            breakpoint: 1024,
            settings: {
                vertical: true,
              infinite:false,
              slidesToShow: 4,
            }
        },{
            breakpoint: 992,
            settings: {
                vertical: false,
              infinite:false,
            }
        },
        {
            breakpoint: 768,
            settings: {
                vertical: false,
              infinite:false,
            }
        },
        {
            breakpoint: 580,
            settings: {
                vertical: false,
               // slidesToShow: 2,
              infinite:false,
            }
        },
        {
            breakpoint: 380,
            settings: {
                vertical: false,
                slidesToShow: 2,
                infinite:false,
            }
        }
    ]
});

/* Vertical Slider Script Start */
/* Disable */
$(document).ready(function() {
    $('.slider').on('init', function(event, slick) {
        updateButtons(slick);
    });

    $('.slider').on('afterChange', function(event, slick, currentSlide) {
        updateButtons(slick);
    });

    function updateButtons(slick) {
        const prevButton = $('.slick-prev');
        const nextButton = $('.slick-next');

        // Disable Previous button if on first slide
        if (slick.currentSlide === 0) {
            prevButton.addClass('slick-disabled').attr('aria-disabled', 'true').prop('disabled', true);
        } else {
            prevButton.removeClass('slick-disabled').attr('aria-disabled', 'false').prop('disabled', false);
        }

        // Disable Next button if on last slide
        if (slick.currentSlide === slick.slideCount - 1) {
            nextButton.addClass('slick-disabled').attr('aria-disabled', 'true').prop('disabled', true);
        } else {
            nextButton.removeClass('slick-disabled').attr('aria-disabled', 'false').prop('disabled', false);
        }
    }

    
});






/* Disable  */ 
/* Model Script Start */
function onClick(element) {
    var img = document.getElementById("img01").src = element.src;

    document.getElementById("modal01").style.display = "block";
}
/* Model Script End */
/* Updated the varaint images Script Start */
$(document).ready(function() {
    // Function to update both the slider image and the thumbnail image
    function updateImageAndInput(hiddenInputValue , notavilable) {
        if (hiddenInputValue) {
            console.log('Updated Hidden Input Value:', hiddenInputValue);
            console.log('If notavilable', notavilable);
            // Update the main slider image
            var $sliderImage = $('.slider-banner-image.slick-current img.feature-img');
            if ($sliderImage.length) {
                if(hiddenInputValue.includes('no-image'))
              {
                   $sliderImage.attr('src', notavilable);
              } else{
                $sliderImage.attr('src', hiddenInputValue);
              }
              
            } else {
            
                console.error('Slider image not found.');
            }

            // Update the thumbnail image
            var $thumbnailImage = $('.thumbnail-image.slick-current img');
            if ($thumbnailImage.length) {
                if(hiddenInputValue.includes('no-image')) {
                   $thumbnailImage.attr('src', notavilable);
               } else{
                $thumbnailImage.attr('src', hiddenInputValue);  
               }
               
            } else {
                console.error('Thumbnail image not found.');
            }
        } else {
            console.error('Hidden input value is not available.');
        }
    }

    // Function to fetch updated value using AJAX
    function fetchUpdatedValue() {
        $.ajax({
            url: window.location.href, // Fetch from the current page URL
            type: 'GET',
            success: function(response) {
                
                var $temp = $('<div>').html(response);
                // var updatedHtml = $temp.find('.product-form__buttons').html();
                // $('.product-form__buttons').html(updatedHtml);
                var updatedValue = $temp.find('#selected-variant-image').val();
                var ifnotUpdatedValue = $('.slider-banner-image.slick-current img').attr('src');
                updateImageAndInput(updatedValue , ifnotUpdatedValue);
                $(".custom-button").load(window.location.href + " .custom-button > *");
            },
            error: function(xhr, status, error) {
                console.error('Failed to fetch updated value:', status, error);
            }
        });
    }
fetchUpdatedValue();
    // Use event delegation to handle clicks on dynamically added swatch labels
    $(document).on('click', '.get-selected-v-img', function() {
        // Fetch and update after a short delay to simulate content update
        setTimeout(fetchUpdatedValue, 800); // Adjust the delay if needed
    });
});
/* Updated the varaint images Script Start */
/* Star Review Js */
document.addEventListener('DOMContentLoaded', function() {
  // Get the div with ID 'manual-judgeme'
  var manualJudgemeDiv = document.getElementById('manual-judgeme');

  // Add a click event listener to the div
  manualJudgemeDiv.addEventListener('click', function() {
    // Get the <li> element with class 'tab-link' and data-tab 'tab-5'
    var targetTab = document.querySelector('li.tab-link[data-tab="tab-5-review"]');
    
    // Trigger a click event on the <li> element
    if (targetTab) {
      targetTab.click();
    }
  });
});
/* Star Review Js */
/* Products Tab*/

/* Append the dynamic value on Document tab using app */
window.onload = function() {
  if (typeof updateButtons === 'function') {

   updateButtons(slick);
  }
    // Function to handle tab switching
    function handleTabSwitch() {
        $('.product-tab-wrap ul.tabs li').click(function() {
            var tab_id = $(this).attr('data-tab');

            $('.product-tab-wrap ul.tabs li').removeClass('current');
            $('.tab-content').removeClass('current');

            $(this).addClass('current');
            $("#" + tab_id).addClass('current');
        });
    }

    // Get the manual and warranty href values
    const manualLink = document.querySelector('.prod-manual-download ul li:nth-child(1) a');
    const warrantyLink = document.querySelector('.prod-manual-download ul li:nth-child(2) a');

    let manualHref = manualLink ? manualLink.getAttribute('href') : null;
    let warrantyHref = warrantyLink ? warrantyLink.getAttribute('href') : null;

    console.log("manualHref====" + manualHref);
    console.log("warrantyHref===" + warrantyHref);

    // Create the HTML for the new content only if manualHref is available
    if (manualHref || warrantyHref) {
        const newTabContent = `
            <div id="tab-document-manual" class="tab-content manual-document-tab-c">
                <div class="main-wrap-w-m">
                    <div class="manual">
                        ${manualHref ? `
                            <strong class="user-manul">User Manual</strong>
                            <a class="download-document-file manual" href="${manualHref}" target="_blank">
                                <img src="https://cdn.shopify.com/s/files/1/0285/4436/8743/files/Group_73.svg?v=1724330503" />
                                Download
                            </a>
                        ` : ''}
                    </div>
                    <div class="warranty">
                        ${warrantyHref ? `
                            <strong class="user-manul warranty">Warranty</strong>
                            <a class="download-document-file manual" href="${warrantyHref}" target="_blank">
                                <img src="https://cdn.shopify.com/s/files/1/0285/4436/8743/files/Group_73.svg?v=1724330503" />
                                Download
                            </a>
                        ` : ''}
                    </div>
                </div>
            </div>
        `;

        // Find the insertion points
        const tabList = document.querySelector('.tab-h-wrap .tabs');
        const proReviewTab = document.querySelector('.pro-review');
        const tab5ReviewContent = document.querySelector('#tab-5-review');

        // Insert the new tab link before .pro-review
        const newTabLink = document.createElement('li');
        newTabLink.classList.add('tab-link');
        newTabLink.classList.add('pro-m-d');
        newTabLink.setAttribute('data-tab', 'tab-document-manual');
        newTabLink.textContent = 'Documents';

        if (tabList && proReviewTab) {
            tabList.insertBefore(newTabLink, proReviewTab);
        }

        // Insert the new tab content before #tab-5-review
        if (tab5ReviewContent) {
            tab5ReviewContent.insertAdjacentHTML('beforebegin', newTabContent);
        }

        // Reinitialize tab functionality to include new tabs
        handleTabSwitch();

        // Optionally, set the first tab as active by default
        const tabLinks = $('.product-tab-wrap ul.tabs li');
        if (tabLinks.length > 0) {
            tabLinks.first().addClass('current');
            const defaultContentId = tabLinks.first().attr('data-tab');
            $("#" + defaultContentId).addClass('current');
        }
    }
};


/* Product Quentity Validation 
  document.addEventListener('DOMContentLoaded', function() {
    const quantityInput = document.getElementById('Quantity-template--15299730505831__main');
    const submitButton = document.getElementById('ProductSubmitButton-template--15299730505831__main');
    const errorMessageContainer = document.querySelector('.error-messag-qty');

    // Function to validate quantity
    function validateQuantity() {
        const quantity = parseInt(quantityInput.value, 10);

        if (quantity > 100) {
            errorMessageContainer.textContent = 'You cannot add more than 100 items in your bag.';
            return false;
        } else {
            errorMessageContainer.textContent = '';
            return true;
        }
    }

    // Handle form submission
    submitButton.addEventListener('click', function(event) {
        if (!validateQuantity()) {
            event.preventDefault(); // Prevent form submission if validation fails
        }
    });

    // Optionally handle form submission directly if the user presses Enter or clicks the submit button
    const form = document.querySelector('form');
    form.addEventListener('submit', function(event) {
        if (!validateQuantity()) {
            event.preventDefault(); // Prevent form submission if validation fails
        }
    });
});
/* Product Quentity Validation */